import React from 'react';
import {
    Box,
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
} from '@chakra-ui/react';
import AdminCarMaintenance from './AdminCarMaintenance';
import MyHireBookings from './MyHireBookings';
import OwnerHireDashboard from './OwnerHireDashboard';
import { useCustomTheme } from '../../../contexts/CustomThemeContext';


const cardsBorderRadii ="8px";

const HireManagerTabsPage = () => {
    const { theme } = useCustomTheme();

    const tabStyles = {
        fontWeight: "700",
        color: theme.name === "dark" ? theme.textMuted : theme.textMuted,
        bg: theme.name === "dark" ? "rgba(255,255,255,0.02)" : "transparent",
        borderTopRadius: "10px",
        borderTopWidth: "2px",
        borderTopColor: "transparent",
        borderLeft: "1px solid transparent",
        borderRight: "1px solid transparent",
        borderBottom: "1px solid transparent",
        transition: "all 0.2s ease",

        _hover: {
            color: theme.text,
            bg: theme.name === "dark" ? "rgba(255,255,255,0.05)" : theme.hover,
        },

        _selected: {
            color: theme.text,
            bg: theme.surface,
            borderTop: `3px solid ${theme.primary}`,
            borderLeft: `1px solid ${theme.border}`,
            borderRight: `1px solid ${theme.border}`,
            borderBottomColor: theme.surface,
            boxShadow: theme.shadowSm,
        },
    };

    return (
        <Box
            bg={theme.surface}
            w="100%"
            p={4}
            borderRadius={cardsBorderRadii}
            border="1px solid"
            borderColor={theme.border}
            boxShadow={theme.shadowSm}
        >
            <Tabs variant="enclosed-colored" colorScheme="teal" defaultIndex={0} mb={8} isLazy>
                <TabList borderColor={theme.divider}>
                    <Tab {...tabStyles}>Owner Hire Dashboard</Tab>
                    <Tab {...tabStyles}>My Hire Bookings</Tab>
                    <Tab {...tabStyles}>Admin Car Maintenance</Tab>
                </TabList>

                <TabPanels>
                    <TabPanel px={0} pt={4}>
                        <OwnerHireDashboard />
                    </TabPanel>

                    <TabPanel px={0} pt={4}>
                        <MyHireBookings />
                    </TabPanel>

                    <TabPanel px={0} pt={4}>
                        <AdminCarMaintenance />
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </Box>
    );
};

export default HireManagerTabsPage;